import * as TK from 'components/PDP/Details/components/ProductOptions/translations/product-options.locale.constants';

export const productOptionsCommonLocale = {
  [TK.UNAVAILABLE]: 'Selected size is not available',
  [TK.QUANTITY_INCREASE_ARIA]: 'Increase quantity',
  [TK.QUANTITY_DECREASE_ARIA]: 'Decrease quantity',
  [TK.QUANTITY_ARIA]: 'Selected quantity',
};
